import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { FunctionComponent } from 'react';
import { GateContent } from 'app/agriculture/routes/Infra/components/content/GateContent';
import { BridgeCrossingContent } from 'app/agriculture/routes/Infra/components/content/BridgeCrossingContent';
import { PaddockContent } from 'app/agriculture/routes/Infra/components/content/PaddockContent';
import { VegetationContent } from 'app/agriculture/routes/Infra/components/content/VegetationContent';
import { FenceContent } from 'app/agriculture/routes/Infra/components/content/FenceContent';
import { DamContent } from 'app/agriculture/routes/Infra/components/content/DamContent';

interface InfraSpecificContentProps {
    infraType: InfraType;
}

const contentForInfra: Partial<Record<InfraType, FunctionComponent>> = {
    'Bridge Crossing': BridgeCrossingContent,
    Dam: DamContent,
    Gate: GateContent,
    Fence: FenceContent,
    Paddock: PaddockContent,
    Vegetation: VegetationContent,
};

export function InfraSpecificContent({ infraType }: InfraSpecificContentProps) {
    const InfraContent = contentForInfra[infraType];

    if (InfraContent == null) return null;

    return <InfraContent />;
}
